import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation, Pagination, EffectCoverflow } from 'swiper/modules';

// Importa estilos de Swiper
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-coverflow';

import './PromotionCarousel.css';
import Item from '../Item/Item';

const PromotionCarousel = () => {
  const [promotions, setPromotions] = useState([]);
  const diasSemana = ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"];

  useEffect(() => {
    const fetchPromotions = async () => {
      try {
        const response = await axios.get('https://pedir-salvatuvianda.p89nps.easypanel.host/api/viandas');
        const promoItems = response.data.filter(item => item.promocion === 'si');
        setPromotions(promoItems);
      } catch (error) {
        console.error('Error al obtener productos en promoción:', error);
      }
    };

    fetchPromotions();
  }, []);

  return (
    <div className="promotion-carousel-container">
      <h2>🔥 Viandas en Promoción 🔥</h2>
      <Swiper
        modules={[Autoplay, Navigation, Pagination]}
        /* effect="coverflow" */
        spaceBetween={20}
        slidesPerView={1}
        breakpoints={{
          464: { slidesPerView: 1 },
          768: { slidesPerView: 2 },
          1024: { slidesPerView: 3 },
        }}
        autoplay={{ delay: 2000, disableOnInteraction: false }}
        loop={true}
        pagination={{ clickable: true }}
        navigation={true}
      >
        {promotions.map(promo => (
          <SwiperSlide key={promo.id}>
            <div className="promo-item">
              <Item item={promo} />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default PromotionCarousel;
